import { List, Create, Edit } from "../Components/index";

export default [
    {
        path: "/parade-type",
        component: List,
        name: "parade-type-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/parade-type/:id/edit",
        component: Edit,
        name: "parade-type-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/parade-type/create",
        component: Create,
        name: "parade-type-create",
        meta: {
            requiresAuth: true,
        },
    },
];
